var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TodoList',_vm._b({attrs:{"context-url":"?in_dashboard=true","from-page":"dashboard"}},'TodoList',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }